import { c as _c } from "react/compiler-runtime";
import { IcoWarning16 } from '@onefootprint/icons';
import { Tooltip } from '@onefootprint/ui';
import type { FieldError } from 'react-hook-form';
type ErrorIndicatorProps = {
  fieldError: FieldError;
};
const ErrorIndicator = t0 => {
  const $ = _c(4);
  const {
    fieldError
  } = t0;
  const t1 = !fieldError.message;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoWarning16 color="error" className="flex-shrink-0" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== fieldError.message || $[2] !== t1) {
    t3 = <Tooltip disabled={t1} content={fieldError.message}>{t2}</Tooltip>;
    $[1] = fieldError.message;
    $[2] = t1;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default ErrorIndicator;